<div *ngIf="show" class="loading-page-container" fxLayout="row" fxLayoutAlign="center center">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</div>
